import type { ReportDateRangeFilter } from 'src/api/generated';
import {
  isReportDateRangeValid,
  type ReportDateRangeTranslator,
} from './report-date-range';

/**
 * Returns whether an advanced-report filter is ready to reach the API.
 */
export const isAdvancedReportQueryEnabled = (
  filters: { dateRange: ReportDateRangeFilter } | null,
  visible: boolean,
  t: ReportDateRangeTranslator
): boolean =>
  Boolean(filters && visible && isReportDateRangeValid(filters.dateRange, t));
